module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item dropdown notification-list"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle arrow-none waves-light waves-effect",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "false",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-email noti-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "noti-icon-badge"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right dropdown-arrow dropdown-arrow-success dropdown-lg",
    attrs: {
      "aria-labelledby": "Preview"
    }
  }, [_c('div', {
    staticClass: "dropdown-item noti-title bg-success"
  }, [_c('h5', [_c('small', [_c('span', {
    staticClass: "label label-danger pull-xs-right"
  }, [_vm._v("7")]), _vm._v("Messages")])])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "notify-icon bg-faded"
  }, [_c('img', {
    staticClass: "img-circle img-fluid",
    attrs: {
      "src": "static/assets/images/users/avatar-2.jpg",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "notify-details"
  }, [_c('b', [_vm._v("Robert Taylor")]), _vm._v(" "), _c('span', [_vm._v("New tasks needs to be done")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("1min ago")])])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "notify-icon bg-faded"
  }, [_c('img', {
    staticClass: "img-circle img-fluid",
    attrs: {
      "src": "static/assets/images/users/avatar-3.jpg",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "notify-details"
  }, [_c('b', [_vm._v("Carlos Crouch")]), _vm._v(" "), _c('span', [_vm._v("New tasks needs to be done")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("1min ago")])])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "notify-icon bg-faded"
  }, [_c('img', {
    staticClass: "img-circle img-fluid",
    attrs: {
      "src": "static/assets/images/users/avatar-4.jpg",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "notify-details"
  }, [_c('b', [_vm._v("Robert Taylor")]), _vm._v(" "), _c('span', [_vm._v("New tasks needs to be done")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("1min ago")])])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item notify-all",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("\n      View All\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce27bd8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/TopBar/Navigation/LiMail.vue
// module id = 726
// module chunks = 1